import { Component, inject, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IdentifyProductRequest } from 'src/app/common/IdentifyProductRequest';
import { ProductIdentificationResponse } from 'src/app/common/IdentifyProductResponse';
import { ProductIdentificationService } from 'src/app/services/product-identification.service';
import { CallApiService } from '../../services/api-action.service';
import { AsyncClickDirective } from '../../directives/async-click.directive';
import { EMPTY, Observable, tap } from 'rxjs';

@Component({
    imports: [FormsModule, AsyncClickDirective],
    selector: 'app-scan',
    templateUrl: './scan.component.html',
    styleUrls: ['./scan.component.css']
})
export class ScanComponent {
  private productIdentificationService = inject(ProductIdentificationService);
  private callApiService = inject(CallApiService);

  readonly identificationProcessed = output<ProductIdentificationResponse>();

  public code: string;

  public identify(): Observable<unknown> {
    if (!this.code) {
      return EMPTY;
    }
    const request = new IdentifyProductRequest(this.code);

    return this.callApiService
      .callWithToasts$(
        this.productIdentificationService.identifyProduct(request),
        null,
        $localize`Leider konnte kein Produkt mit diesem Code ermittelt werden.`
      )
      .pipe(tap((response: ProductIdentificationResponse) => this.identificationProcessed.emit(response)));
  }
}
